import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import {
  Box,
  Container,
  Stack,
  Typography,
  Button,
  SvgIcon,
} from "@mui/material";
import { FC, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { Layout } from "../../components/layout";
import { Search } from "../../components/search";
import useAuth from "../../hooks/useAuth";
import {
  recuperarTodosPerfisCompletos,
  deletarPerfilPorId,
} from "../../services/perfil";
import { PerfilCompleto, AxiosResponse } from "../../types";
import { TablePerfis } from "./tablePerfis";

const HomePerfis: FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [perfis, setPerfis] = useState<PerfilCompleto[]>([]);

  const fetchPerfis = async () => {
    try {
      setIsLoading(true);
      const response = await recuperarTodosPerfisCompletos();
      if (response) {
        setPerfis(response.data);
      }
    } catch (error) {
      toast.error("Erro ao recuperar perfis: " + error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user?.idUsuario && user?.tipo === "ADMIN") {
      fetchPerfis();
    }
  }, [user]);

  const handleAdd = () => {
    navigate(`/perfil`);
  };

  const handleEdit = (id: number) => {
    navigate(`/perfil/${id}`);
  };

  const handleDelete = async (id: number) => {
    try {
      await deletarPerfilPorId(String(id));
      fetchPerfis();
      toast.success("Perfil deletado com sucesso!");
    } catch (error) {
      toast.error("Erro ao deletar perfil: " + error);
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredData = perfis.filter(
    (item) =>
      item.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.valorCsp.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.tipo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.painelNome &&
        item.painelNome.toLowerCase().includes(searchTerm.toLowerCase())),
  );

  return (
    <Layout>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={3}>
            <Stack direction="row" justifyContent="space-between" spacing={4}>
              <Stack spacing={1}>
                <Typography variant="h4">Perfis</Typography>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Button
                  startIcon={
                    <SvgIcon fontSize="small">
                      <PlusIcon />
                    </SvgIcon>
                  }
                  variant="contained"
                  onClick={handleAdd}
                >
                  Adicionar
                </Button>
              </Stack>
            </Stack>
            <Search onChange={handleSearchChange} />
            <TablePerfis
              items={filteredData}
              onEdit={handleEdit}
              onDelete={handleDelete}
              isLoading={isLoading}
            />
          </Stack>
        </Container>
      </Box>
    </Layout>
  );
};

export default HomePerfis;
